import axios from "axios";

// axios.defaults.baseURL = "http://192.168.2.248:8031s/";
// const baseUrl = "http://192.168.2.248:8031s/";
// axios.defaults.baseURL = "http://api.chinalocus.coms/";
// const baseUrl = "http://api.chinalocus.coms/";
axios.defaults.baseURL = "http://api.chinalocus.com/";
const baseUrl = "http://api.chinalocus.com/";
const http = (url, _this, options, back) => {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: "POST",
      data: options,
    })
      .then((res) => {
        if (res.data.Success) {
          console.log("res=", res);
          let resData = res.data.Data;
          resolve(resData);
        } else {
          if (back == "back") {
            reject(res.data.Message);
          } else {
            this.$message(res.data.Message);
            // _this.$confirm(res.data.Message, _this.$t("user.er"), {
            //   confirmButtonText: _this.$t("user.determine"),
            //   showCancelButton: false,
            //   type: "warning",
            // })
            reject(res.data.Message);
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export { http, baseUrl };
